import { Theme, useTheme } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'

// MOBILE = ['xs', 'sm']
// TABLET = ['md']
// DESKTOP = ['lg', 'xl']

export const useFormFactor = () => {
  const theme: Theme = useTheme()
  const isSmDown = useMediaQuery(theme.breakpoints.down('md'))
  const isMdDown = useMediaQuery(theme.breakpoints.down('lg'))
  const isMdUp = useMediaQuery(theme.breakpoints.up('lg'))
  return {
    isMobile: isSmDown,
    isTablet: isMdDown,
    isDesktop: isMdUp,
  }
}
